import * as React from 'react';
import { Link } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';

import InnerHeader from "./InnerHeader"
import MainMenu from './MainMenu';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

function MyWebApps(){
    const columns = [
        { id: 'preview', label: 'Preview', minWidth: 200 },
        { id: 'title', label: 'Title', minWidth: 250 },
        { id: 'category', label: 'Category', minWidth: 150 },
        { id: 'description', label: 'Description', minWidth: 300 },
        { id: 'link', label: 'Link', minWidth: 30 },
    ];

    const rows = [
        {
        title: "3D Solid Viewer",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/3d-solid-viewer.jpg",
        description: "Viewing 3D solid online.",
        keyword: "Cone, Cube, Cylinder, Parallelepiped, Regular Dodecahedron, Regular Icosahedron, Regular Octahedron, Regular Rectangular Pyramid, Regular Tetrahedron, Right Triangular Prism, Sphere, Platonic Solid, Solid Geometry",
        link: "https://codinglab.huostravelblog.com/math/3d-solid-viewer/index.php"
        },
        {
        title: "ASCII Table Lookup",
        category: "Programming",
        image: "https://codinglab.huostravelblog.com/image/apps/ascii-table-lookup.jpg",
        description: "Ascii Table, Keystroke Recognition.",
        keyword: "",
        link: "https://codinglab.huostravelblog.com/programming/ascii-table-lookup/index.php"
        },
        {
        title: "Birthday Paradox",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/birthday-paradox.jpg",
        description: "What is the chance that at Least two people at a group has the same birthday?",
        keyword: "Birthdy Problem",
        link: "https://codinglab.huostravelblog.com/math/birthday-paradox/index.php"
        },
        /*{
        title: "Caesar Cipher Encipherer and Decipher",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/caesar-cipher-encipherer-and-decipher.jpg",
        description: "Enciphering and Deciphering Caesar Cipher. Solve Caesar Cipher with Best Guest.",
        keyword: "Solving Caesar Cipher, Decoding.",
        link: "https://codinglab.huostravelblog.com/math/caesar-cipher-encipherer-and-decipher/index.php"
        },*/
        {
        title: "Cayley Tables Generator",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/cayley-tables-generator.jpg",
        description: "Generate Cayley Tables or Operation Tables online.",
        keyword: "Multiplication Table, Group Theory",
        link: "https://codinglab.huostravelblog.com/math/cayley-tables-generator/index.php"
        },
        {
        title: "Chinese Remainder Theorem Problem Solver",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/chinese-remainder-theorem-problem-solver.jpg",
        description: "System of Linear Congruences Solver.",
        keyword: "",
        link: "https://codinglab.huostravelblog.com/math/chinese-remainder-theorem-problem-solver/index.php"
        },
        {
        title: "Clock",
        category: "Other",
        image: "https://codinglab.huostravelblog.com/image/apps/clock.jpg",
        description: "Online analog and digital clocks with different styles.",
        keyword: "Simple, Roman, High Contrast",
        link: "https://codinglab.huostravelblog.com/other/clock/index.php"
        },
        {
        title: "Coprime Finder",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/coprime-finder.jpg",
        description: "Find all numbers less than (or the closet to) and relatively prime to a given number.",
        keyword: "Coprime, Relative Primes, RSA",
        link: "https://codinglab.huostravelblog.com/math/coprime-finder/index.php"
        },
        {
        title: "Countdown Timer",
        category: "Other",
        image: "https://codinglab.huostravelblog.com/image/apps/countdown-timer.jpg",
        description: "Countdown for a specific interval; Countdown to a specific time.",
        keyword: "Count down, count-down.",
        link: "https://codinglab.huostravelblog.com/other/countdown-timer/index.php"
        },
        {
        title: "Dim Sum Reference Sheet",
        category: "Travel",
        image: "https://codinglab.huostravelblog.com/image/apps/dim-sum-reference-sheet.jpg",
        description: "Help you order your favorite dim sum.",
        keyword: "dimsum, dimsum guide, chinese food, dian xin",
        link: "https://codinglab.huostravelblog.com/travel/dim-sum-reference-sheet/index.php"
        },
        {
        title: "Dotplot Generator",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/dotplot-generator.jpg",
        description: "Make Dotplot.",
        keyword: "dot plot, dotplot, categorical, distribution, normal, plot, statistics, discrete",
        link: "https://codinglab.huostravelblog.com/math/dotplot-generator/index.php"
        },
        {
        title: "Euclidean Algorithm Step by Step Solver",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/euclidean-algorithm-step-by-step-solver.jpg",
        description: "Using Euclidean Algorithm to find the Greatest Common Divisor (GCD) of Two Positive Integers with Step by Step Explanation.",
        keyword: "modular multiplicative inverse, extended euclidean algorithm",
        link: "https://codinglab.huostravelblog.com/math/euclidean-algorithm-step-by-step-solver/index.php"
        },
        {
        title: "Factor Pair Finder",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/factor-pair-finder.jpg",
        description: "Find all factor pairs of an integer.",
        keyword: "Quadratic Equation",
        link: "https://codinglab.huostravelblog.com/math/factor-pair-finder/index.php"
        },
        {
        title: "Fractal Generator",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/fractal-generator.jpg",
        description: "Generate Koch Curve, Sierpinski Triangle, Mandelbrot Set, and other fractals online.",
        keyword: "Basilica,Barnsley Fern,Box Fractal,Cantor Dust,Cantor Set,Dendrite Fractal,Douady's Rabbit,Dragon Curve,Gosper Island,H Fractal,Hilbert Curve,Koch Curve,Koch Snowflake,Levy C Curve,Mandelbrot Set,Peano-Gosper Curve,Pythagoras Tree,Sierpinski Carpet,Sierpinski Triangle",
        link: "https://codinglab.huostravelblog.com/math/fractal-generator/index.php"
        },
        {
        title: "GCD and LCM Calculator",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/gcd-and-lcm-calculator.jpg",
        description: "Find the greatest common divisor (GCD) and Least Common Multiple (LCM) of a list of integers",
        keyword: "Euclidean algorithm",
        link: "https://codinglab.huostravelblog.com/math/gcd-and-lcm-calculator/index.php"
        },
        {
        title: "Geometric Transformation Visualizer",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/geometric-transformation-visualizer.jpg",
        description: "Step by step showing how translations, reflections, and rotations work",
        keyword: "",
        link: "https://codinglab.huostravelblog.com/math/geometric-transformation-visualizer/index.php"
        },
        {
        title: "Group Assigner",
        category: "Other",
        image: "https://codinglab.huostravelblog.com/image/apps/group-assigner.jpg",
        description: "Randomly assign students to different groups.",
        keyword: "random group assignment",
        link: "https://codinglab.huostravelblog.com/other/group-assigner/index.php"
        },
        {
        title: "Multiple Choice Selector",
        category: "Other",
        image: "https://codinglab.huostravelblog.com/image/apps/multiple-choice-selector.jpg",
        description: "Instantly gathers multiple choice answers.",
        keyword: "online response, clicker",
        link: "https://codinglab.huostravelblog.com/other/multiple-choice-selector/index.php"
        },
        {
        title: "Integer Partitioner",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/integer-partitioner.jpg",
        description: "Find all partitions of a givin positive integer.",
        keyword: "Summand, Different Sums,",
        link: "https://codinglab.huostravelblog.com/math/integer-partitioner/index.php"
        },
        {
        title: "Keyboard Event Tester",
        category: "Programming",
        image: "https://codinglab.huostravelblog.com/image/apps/keyboard-event-tester.jpg",
        description: "Show KeyCodes for KeyDown, KeyUp, and KeyPress Events.",
        keyword: "",
        link: "https://codinglab.huostravelblog.com/programming/keyboard-event-tester/index.php"
        },
        {
        title: "Letter Frequency Analyser",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/letter-frequency-analyser.jpg",
        description: "Cryptanalysis: Frequency Analysis for Simple Substitution Ciphers (such as caesar cipher).",
        keyword: "Caesar Cipher, Vigenere Cipher",
        link: "https://codinglab.huostravelblog.com/math/letter-frequency-analyser/index.php"
        },
        {
        title: "Logic Expression Evaluator",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/logic-expression-evaluator.jpg",
        description: "Evaluating Logic Expression, Generate Truth Table.",
        keyword: "",
        link: "https://codinglab.huostravelblog.com/math/logic-expression-evaluator/index.php"
        },
        {
        title: "Mandelbrot Set Orbit Tracer",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/mandelbrot-set-orbit-tracer.jpg",
        description: "Visualize the Orbits of 0 under x^2 + c",
        keyword: "Mandelbrot orbits graphing",
        link: "https://codinglab.huostravelblog.com/math/mandelbrot-set-orbit-tracer/index.php"
        },
        {
        title: "Matrix Determinant Calculator",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/matrix-determinant-calculator.jpg",
        description: "Calculate the matrix determinant online",
        keyword: "",
        link: "https://codinglab.huostravelblog.com/math/matrix-determinant-calculator/index.php"
        },
        {
        title: "Maze Generator",
        category: "Other",
        image: "https://codinglab.huostravelblog.com/image/apps/maze-generator.jpg",
        description: "Generate playable maze",
        keyword: "playable interactive maze, maze puzzle, walk maze, maze game",
        link: "https://codinglab.huostravelblog.com/other/maze-generator/index.php"
        },
        {
        title: "Modular Inverse Table Generator",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/modular-inverse-table-generator.jpg",
        description: "Find all modular inverses for a given modulus",
        keyword: "",
        link: "https://codinglab.huostravelblog.com/math/modular-inverse-table-generator/index.php"
        },
        {
        title: "Number Base Converter",
        category: "Programming",
        image: "https://codinglab.huostravelblog.com/image/apps/number-base-converter.jpg",
        description: "Convert a number between different number bases. binary, octal, hex, hexadecimal, decimal, base",
        keyword: "",
        link: "https://codinglab.huostravelblog.com/programming/number-base-converter/index.php"
        },
        {
        title: "One Variable Statistics Calculator",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/one-variable-statistics-calculator.jpg",
        description: "Calculate one variable statistics, construct Box-and-Whisker plots.",
        keyword: "Five Number Summary, Mean (Average), Quartile, Outliner, Range, Mode, Interquartile Range, Corrected Sum of Squares, Variance, Standard Deviation",
        link: "https://codinglab.huostravelblog.com/math/one-variable-statistics-calculator/index.php"
        },
        {
        title: "Pascal's Triangle Generator",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/pascals-triangle-generator.jpg",
        description: "Pascal's Triangle Online Generator",
        keyword: "binomial coefficients, Yang Hui's triangle, Tartaglia's triangle",
        link: "https://codinglab.huostravelblog.com/math/pascals-triangle-generator/index.php"
        },
        {
        title: "Permutation List Generator",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/permutation-list-generator.jpg",
        description: "Generating all possible permutations for a string sequence.",
        keyword: "",
        link: "https://codinglab.huostravelblog.com/math/permutation-list-generator/index.php"
        },
        {
        title: "Polygon Calculator",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/polygon-calculator.jpg",
        description: "Calculate the perimeter, area, and centroid of a polygon.",
        keyword: "Area, Perimeter, Polygon, Center of Mass, Center of Gravity",
        link: "https://codinglab.huostravelblog.com/math/polygon-calculator/index.php"
        },
        {
        title: "Prime Factorization Calculator",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/prime-factorization-calculator.jpg",
        description: "Find the Prime Factorization of a Given Integer.",
        keyword: "",
        link: "https://codinglab.huostravelblog.com/math/prime-factorization-calculator/index.php"
        },
        {
        title: "Quadratic Equation Step by Step Solver",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/quadratic-equation-step-by-step-solver.jpg",
        description: "Quadratic Equation Solver with Step by Step Explanation using up to three different methods.",
        keyword: "Quadratic formula, Factor Quadratic, Factor Quadratic by grouping",
        link: "https://codinglab.huostravelblog.com/math/quadratic-equation-step-by-step-solver/index.php"
        },
        {
        title: "Queue Manager",
        category: "Other",
        image: "https://codinglab.huostravelblog.com/image/apps/simple-waitlist-manager.jpg",
        description: "Managing queue in meeting, office hours, etc.",
        keyword: "office hour, queue, customer, signup, sign up, student",
        link: "https://codinglab.huostravelblog.com/other/queue-manager/index.php"
        },
        {
        title: "Random Number Generator",
        category: "Programming",
        image: "https://codinglab.huostravelblog.com/image/apps/random-number-generator.jpg",
        description: "Online Customized Random Number Generator.",
        keyword: "Random Strings",
        link: "https://codinglab.huostravelblog.com/programming/random-number-generator/index.php"
        },
        {
        title: "Random Number Picker",
        category: "Other",
        image: "https://codinglab.huostravelblog.com/image/apps/random-number-picker.jpg",
        description: "Pick a Random Integer.",
        keyword: "",
        link: "https://codinglab.huostravelblog.com/other/random-number-picker/index.php"
        },
        {
        title: "Simple Arithmetic Expression Solver",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/simple-arithmetic-expression-solver.jpg",
        description: "Solving multiple arithmetic expressions at once.",
        keyword: "Solving arithmetic equations",
        link: "https://codinglab.huostravelblog.com/math/simple-arithmetic-expression-solver/index.php"
        },
        {
        title: "Sieve of Eratosthenes Player",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/sieve-of-eratosthenes-player.jpg",
        description: "Step by step showing how the Sieve of Eratosthenes works.",
        keyword: "find prime, prime number generator",
        link: "https://codinglab.huostravelblog.com/math/sieve-of-eratosthenes-player/index.php"
        },
        {
        title: "Stem-and-Leaf Plot Generator",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/stem-and-leaf-plot-generator.jpg",
        description: "Make Stem-and-Leaf plot.",
        keyword: "stem-and-leaf, stem, leaf, plot, statistics, discrete, categorical",
        link: "https://codinglab.huostravelblog.com/math/stem-and-leaf-plot-generator/index.php"
        },
        {
        title: "Stopwatch",
        category: "Other",
        image: "https://codinglab.huostravelblog.com/image/apps/stopwatch.jpg",
        description: "A stopwatch program that is able to display in different formats.",
        keyword: "seconds unit, seconds only",
        link: "https://codinglab.huostravelblog.com/other/stopwatch/index.php"
        },
        {
        title: "String Manipulator",
        category: "Programming",
        image: "https://codinglab.huostravelblog.com/image/apps/string-manipulator.jpg",
        description: "Manipulating strings online.",
        keyword: "Lowercase, Uppercase, Capitalize Titles, Reverse a String,",
        link: "https://codinglab.huostravelblog.com/programming/string-manipulator/index.php"
        },
        {
        title: "Sudoku Solver",
        category: "Other",
        image: "https://codinglab.huostravelblog.com/image/apps/sudoku-solver.jpg",
        description: "Solving Sudoku Online.",
        keyword: "",
        link: "https://codinglab.huostravelblog.com/other/sudoku-solver/index.php"
        },
        {
        title: "Subsets Generator",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/subsets-generator.jpg",
        description: "Generating all possible subsets of a given sets.",
        keyword: "subset, power set",
        link: "https://codinglab.huostravelblog.com/math/subsets-generator/index.php"
        },
        {
        title: "System of Linear Equations Solver",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/system-of-linear-equations-solver.jpg",
        description: "Solving systems of linear equations online.",
        keyword: "",
        link: "https://codinglab.huostravelblog.com/math/system-of-linear-equations-solver/index.php"
        },
        {
        title: "Tally Counter",
        category: "Other",
        image: "https://codinglab.huostravelblog.com/image/apps/tally-counter.jpg",
        description: "Online Tally Counter",
        keyword: "click counter, counting",
        link: "https://codinglab.huostravelblog.com/other/tally-counter/index.php"
        },
        {
        title: "Two Variable Statistics Calculator",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/two-variable-statistics-calculator.jpg",
        description: "Calculate two variable statistics, Correlation, Line of Best Fit, Residual Plot.",
        keyword: "Corrected Sum of Cross Products, Covariance, Correlation Coefficient",
        link: "https://codinglab.huostravelblog.com/math/two-variable-statistics-calculator/index.php"
        },
        {
        title: "Two Way Table Analyser",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/two-way-table-analyser.jpg",
        description: "Construct Two-Way Frequency Table, Relative Frequency Tables, Expected Counts, Chi-Square.",
        keyword: "Contingency Tables, Joint Frequencies,Marginal Frequencies, Relative Frequencies",
        link: "https://codinglab.huostravelblog.com/math/two-way-table-analyser/index.php"
        },
        {
        title: "Unit Circle Visualizer",
        category: "Math",
        image: "https://codinglab.huostravelblog.com/image/apps/unit-circle-visualizer.jpg",
        description: "Visualize Trigonometric Function Values on a Unit Circle.",
        keyword: "Trig Functions, Trigonometric Functions",
        link: "https://codinglab.huostravelblog.com/math/unit-circle-visualizer/index.php"
        },
        {
        title: "Yes-No Counter",
        category: "Other",
        image: "https://codinglab.huostravelblog.com/image/apps/yes-no-counter.jpg",
        description: "Online Tally Counter for Two Categories.",
        keyword: "yes no yay nay aye",
        link: "https://codinglab.huostravelblog.com/other/yes-no-counter/index.php"
        }
    ];    

      const [page, setPage] = React.useState(0);
      const [rowsPerPage, setRowsPerPage] = React.useState(25);
    
      const handleChangePage = (event, newPage) => {
        setPage(newPage);
      };
    
      const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
      };

    return(
        <div>
            <InnerHeader />

            <Paper elevation={2} style={{padding:"10px", marginTop:"10px"}}>
                <TableContainer sx={{ height: "60vh" }}>
                    <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                        {columns.map((column) => (
                            <TableCell
                            style={{ minWidth: column.minWidth }}
                            >
                            {column.label}
                            </TableCell>
                        ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows
                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((row) => {
                            return (
                            <TableRow hover role="checkbox" tabIndex={-1}>
                                <TableCell><img src={row.image} /></TableCell>
                                <TableCell>{row.title}</TableCell>
                                <TableCell>{row.category}</TableCell>
                                <TableCell>{row.description}</TableCell>
                                <TableCell><a href={row.link} target='_blank'><OpenInNewIcon /></a></TableCell>
                            </TableRow>
                            );
                        })}
                    </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[10, 25, 50]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </Paper>
            <MainMenu shareLink="https://huoatwork.github.io/#/links" />
        </div>
    )
     
}

export default MyWebApps